export const RIO4RENTAL_SKU = 'rio-sku00000096';

export const isRIO4RentalProductId = (productId?: string) => productId?.toLocaleLowerCase() === RIO4RENTAL_SKU;
